import { Stack, type StackProps } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = Omit<
	StackProps,
	"direction" | "alignItems" | "justifyContent" | "children"
> & {
	label: ReactNode;
	value: ReactNode;
};

export const LabeledValueRow: FC<Props> = ({ label, value, ...stackProps }) => (
	<Stack
		direction="row"
		alignItems="center"
		justifyContent="space-between"
		{...stackProps}
	>
		{label}
		{value}
	</Stack>
);
